(function ($, Drupal) {
  Drupal.behaviors.testimonialVideos = {
    attach: function (context, settings) {
      once('testimonialVideos', '.student-testimonials__video', context).forEach(function (element) {
        const $element = $(element);
        const $iframe = $element.find('iframe');
        let src = $iframe.attr('data-src');
        if (!src) {
          src = $iframe.attr('src');
        }

        // Check the url html contents from response.
        $.get(src, function (data) {
          if (!data) {
            $element.hide();
          }
        }).fail(function () {
          $element.hide();
        });
      });
    }
  };
})(jQuery, Drupal);
